/*
 * @Author: LZT
 * @Date: 2024-12-17 09:30:20
 * @LastEditors: ITDLCL
 * @Description:股票行情
 */
import Layout from "@/Layout";
export default [
  {
    path: "/stockQuotation",
    name: "stockQuotation",
    redirect: "/stockQuotation/index",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/stockQuotation/index.vue"),
        meta: {
          icon: "guide",
          title: "行情",
          keepAlive: false,
          showFooter: true,
          showHead: false,
          forbidAuth: true
        }
      },
      {
        path: "bkList",
        name: "stockQuotationbkList",
        component: () => import("@/views/stockQuotation/bkList.vue"),
        meta: {
          icon: "guide",
          title: "板块排行",
          keepAlive: true,
          showHead: true,
          showLeft: true,
          showRight: true,
          forbidAuth: false // 自定义路由元信息 在路由守卫中可以使用 判断是否需要身份验证
        }
      }
    ]
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("@/views/detail/index.vue"),
    meta: {
      title: "个股K线图"
    }
  },
  {
    path: "/detailFlutter",
    name: "detailFlutter",
    component: () => import("@/views/detail/indexFlutter.vue"),
    meta: {
      title: "", // 个股K线图Flutter版
    }
  },
];
